import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Mail, Heart } from 'lucide-react';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    if (email.includes('@')) {
      setSubscribed(true);
      setEmail('');
      setTimeout(() => setSubscribed(false), 3500);
    }
  };

  return (
    <footer className="bg-[#3a4a3b] text-[#f6f2ea] mt-24">
      {/* Newsletter band */}
      <div className="border-b border-white/10">
        <div className="max-w-6xl mx-auto px-6 lg:px-10 py-16 text-center">
          <h3 className="font-serif-elegant text-4xl md:text-5xl mb-4">Stay Grounded With Us</h3>
          <p className="text-sm text-[#dcd6c7] max-w-xl mx-auto mb-8 leading-relaxed">
            Sign up for gentle notes on new products, seasonal remedies and the little rituals that keep us well.
          </p>
          <form onSubmit={submit} className="flex flex-col sm:flex-row max-w-md mx-auto gap-3">
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="your@email.com"
              className="flex-1 bg-transparent border border-[#dcd6c7]/40 px-4 py-3 text-sm placeholder:text-[#dcd6c7]/70 focus:outline-none focus:border-[#dcd6c7]"
              required
            />
            <button className="btn-outline !border-[#dcd6c7] !text-[#dcd6c7] hover:!bg-[#dcd6c7] hover:!text-[#3a4a3b]">
              Subscribe
            </button>
          </form>
          {subscribed && <p className="mt-4 text-sm text-[#dcd6c7]">Thank you for subscribing! &#10084;</p>}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="font-serif-elegant text-2xl mb-3">Herbs We Love</div>
          <p className="text-sm text-[#dcd6c7] leading-relaxed">
            Handcrafted herbal &amp; CBD wellness rooted in the principles of healing and harmony.
          </p>
          <div className="flex gap-4 mt-6">
            <a href="https://www.instagram.com/herbswelove?igsh=NTc4MTIwNjQ2YQ%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="hover:text-white transition-colors"><Instagram className="w-5 h-5" /></a>
            <a href="https://www.facebook.com/profile.php?id=61577758914367&mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="hover:text-white transition-colors"><Facebook className="w-5 h-5" /></a>
            <a href="mailto:connectwithanherbalist@outlook.com" aria-label="Email" className="hover:text-white transition-colors"><Mail className="w-5 h-5" /></a>
          </div>
        </div>

        <div>
          <div className="uppercase tracking-widest text-xs mb-4 text-[#dcd6c7]">Shop</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/collections/all" className="link-underline">All Products</Link></li>
            <li><Link to="/collections/all" className="link-underline">Elixirs</Link></li>
            <li><Link to="/collections/all" className="link-underline">Skincare</Link></li>
            <li><Link to="/collections/all" className="link-underline">Bundles &amp; Gifts</Link></li>
          </ul>
        </div>

        <div>
          <div className="uppercase tracking-widest text-xs mb-4 text-[#dcd6c7]">Help</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="link-underline">About</Link></li>
            <li><Link to="/faq" className="link-underline">FAQ</Link></li>
            <li><Link to="/glossary" className="link-underline">Herb Glossary</Link></li>
            <li><Link to="/archive" className="link-underline">Herb Archive</Link></li>
            <li><Link to="/recipes" className="link-underline">Recipe Journal</Link></li>
            <li><Link to="/rituals" className="link-underline">Saved Rituals</Link></li>
            <li><Link to="/about" className="link-underline">Contact</Link></li>
            <li><Link to="/policies/shipping" className="link-underline">Shipping Policy</Link></li>
            <li><Link to="/policies/refund" className="link-underline">Refund Policy</Link></li>
            <li><Link to="/policies/privacy" className="link-underline">Privacy Policy</Link></li>
            <li><Link to="/policies/terms" className="link-underline">Terms of Service</Link></li>
          </ul>
        </div>

        <div>
          <div className="uppercase tracking-widest text-xs mb-4 text-[#dcd6c7]">Our Promise</div>
          <p className="text-sm text-[#dcd6c7] leading-relaxed">
            Every product is handcrafted in small batches with organic, ethically sourced ingredients &mdash; and shipped with love from the Herbs We Love team.
          </p>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row justify-between items-center gap-3 text-xs text-[#dcd6c7]">
          <div>&copy; {new Date().getFullYear()} Herbs We Love. All rights reserved.</div>
          <div className="flex items-center gap-2">Made with <Heart className="w-3 h-3 fill-current" /> for holistic wellness</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
